import {BillingController} from "../../billing_controller";

export default class extends BillingController {
  static targets = ["delete_link"]

  destroyTransaction(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    this._deleteTransaction(url);
  }

  //
  // Private
  //
  _deleteTransaction(url) {
    let confirmMessage = this.data.get("confirm-text");
    if (confirm(confirmMessage)) {
      Rails.ajax({
        url: url,
        type: 'delete',
        success: (data) => {
          if (data) {
            super._successNotify(data.notification_title, data.notification_message);
            window.location.reload();
          }
        },
        error: (data) => {
          if (data) {
            super._errorNotify(data.notification_title, data.notification_message);
          }
        }
      })
    }
  }
}